import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './components/scripts/login.component';
import { AuthService } from './services/auth.service';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AuthRoutingModule
  ],
  declarations: [
    LoginComponent
  ],
  providers: [AuthService]
})

export class AuthenticationModule { }



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.module.ts